// Vimeo helpers — strictly background players without metadata.
// DO NOT show titles, byline, portrait — set background=1 to hide all chrome.
export const vimeoBgUrl = (id, { autoplay = 1, muted = 1, loop = 1, background = 1 } = {}) =>
  `https://player.vimeo.com/video/${id}?autoplay=${autoplay}&muted=${muted}&loop=${loop}&background=${background}&dnt=1`;

export const vimeoFullUrl = (id) =>
  `https://player.vimeo.com/video/${id}?autoplay=1&muted=0&title=0&byline=0&portrait=0&dnt=1`;

// Free thumbnail proxy — returns clean Vimeo poster
export const vimeoThumb = (id) => `https://vumbnail.com/${id}.jpg`;
export const vimeoThumbHQ = (id) => `https://vumbnail.com/${id}_large.jpg`;

// Prefer the official Vimeo poster (from oEmbed) when present, else vumbnail fallback.
export const projectPoster = (project) =>
  project?.thumbnail_url || vimeoThumbHQ(project?.vimeo_id);
